// Dados dos produtos e conteúdo do site
export const products = [
  {
    id: 1,
    name: "Lei de Execução Penal (LEP)",
    description: "Domine a Lei de Execução Penal com flashcards completos e atualizados",
    benefits: [
      "Revisão ativa e eficiente",
      "Conteúdo atualizado",
      "Questões comentadas",
      "Metodologia comprovada"
    ],
    price: "9,99",
    originalPrice: "19,98",
    discount: "50%",
    link: "https://pay.kiwify.com.br/Iamhov0",
    icon: "Scale"
  },
  {
    id: 2,
    name: "Direito Constitucional",
    description: "Flashcards completos de Direito Constitucional para sua aprovação",
    benefits: [
      "Teoria completa em cards",
      "Jurisprudência atualizada",
      "Resumos esquematizados",
      "Revisões programadas"
    ],
    price: "9,99",
    originalPrice: "19,98",
    discount: "50%",
    link: "https://pay.kiwify.com.br/FNYs6me",
    icon: "BookOpen"
  },
  {
    id: 3,
    name: "Direito Administrativo",
    description: "Aprenda Direito Administrativo de forma rápida e objetiva",
    benefits: [
      "Conteúdo esquematizado",
      "Foco em concursos",
      "Doutrina e jurisprudência",
      "Memorização facilitada"
    ],
    price: "9,99",
    originalPrice: "19,98",
    discount: "50%",
    link: "https://pay.kiwify.com.br/KTrRzhO",
    icon: "Building"
  },
  {
    id: 4,
    name: "Direito Penal",
    description: "Flashcards completos para dominar o Direito Penal",
    benefits: [
      "Teoria do crime completa",
      "Parte especial detalhada",
      "Súmulas organizadas",
      "Questões práticas"
    ],
    price: "9,99",
    originalPrice: "19,98",
    discount: "50%",
    link: "https://pay.kiwify.com.br/uqVFIkV",
    icon: "Gavel"
  },
  {
    id: 5,
    name: "Processo Penal",
    description: "Domine o Processo Penal com metodologia eficiente",
    benefits: [
      "Procedimentos completos",
      "Provas e recursos",
      "Súmulas essenciais",
      "Casos práticos"
    ],
    price: "9,99",
    originalPrice: "19,98",
    discount: "50%",
    link: "https://pay.kiwify.com.br/EeKqU44",
    icon: "FileText"
  },
  {
    id: 6,
    name: "Direito Civil",
    description: "Flashcards completos de Direito Civil para sua aprovação",
    benefits: [
      "Parte geral e especial",
      "Contratos e obrigações",
      "Direito das coisas",
      "Família e sucessões"
    ],
    price: "9,99",
    originalPrice: "19,98",
    discount: "50%",
    link: "https://pay.kiwify.com.br/YRaUfhA",
    icon: "Users"
  },
  {
    id: 7,
    name: "Processo Civil",
    description: "Aprenda Processo Civil de forma prática e objetiva",
    benefits: [
      "Procedimentos atualizados",
      "CPC esquematizado",
      "Recursos e prazos",
      "Jurisprudência relevante"
    ],
    price: "9,99",
    originalPrice: "19,98",
    discount: "50%",
    link: "https://pay.kiwify.com.br/92VEYgY",
    icon: "Briefcase"
  },
  {
    id: 8,
    name: "Ética – OAB",
    description: "Flashcards essenciais de Ética para aprovação na OAB",
    benefits: [
      "Estatuto da advocacia",
      "Código de ética completo",
      "Infrações e sanções",
      "Questões comentadas"
    ],
    price: "9,99",
    originalPrice: "19,98",
    discount: "50%",
    link: "https://pay.kiwify.com.br/0Drvj3E",
    icon: "Award"
  }
];

export const bundleOffer = {
  title: "Pacote Completo - Todas as Disciplinas",
  description: "Adquira todos os flashcards com desconto adicional",
  products: 8,
  totalOriginalPrice: "79,92",
  bundlePrice: "48,99",
  discount: "39%",
  savings: "30,93",
  link: "https://pay.kiwify.com.br/L5hXJ8s"
};

export const testimonials = [
  {
    id: 1,
    name: "Carlos Silva",
    role: "Aprovado PM-SP",
    text: "Passei na PM estudando com os flashcards do Direito em 5 Minutos. A revisão ficou muito mais eficiente!",
    rating: 5
  },
  {
    id: 2,
    name: "Ana Paula Oliveira",
    role: "Aprovada TJ-RJ",
    text: "Finalmente consegui revisar tudo com eficiência. Os flashcards são objetivos e diretos ao ponto!",
    rating: 5
  },
  {
    id: 3,
    name: "Roberto Mendes",
    role: "Aprovado OAB",
    text: "Material de excelente qualidade. Consegui organizar meus estudos e fui aprovado na OAB!",
    rating: 5
  }
];

export const features = [
  {
    icon: "BookOpen",
    title: "Revisão Ativa",
    description: "Método de flashcards comprovado cientificamente para fixação de conteúdo"
  },
  {
    icon: "Zap",
    title: "Aprendizado Rápido",
    description: "Conteúdo objetivo e direto ao ponto. Aprenda em minutos, não em horas"
  },
  {
    icon: "Target",
    title: "Foco em Provas",
    description: "Material elaborado com base nas questões mais cobradas em concursos"
  },
  {
    icon: "Brain",
    title: "Memorização Inteligente",
    description: "Técnicas de memorização para fixar o conteúdo de forma permanente"
  },
  {
    icon: "TrendingUp",
    title: "Alto Rendimento",
    description: "Maximize seu tempo de estudo com método comprovado"
  },
  {
    icon: "CheckCircle",
    title: "Conteúdo Completo",
    description: "Todo o conteúdo necessário para sua aprovação em um só lugar"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Escolha sua matéria",
    description: "Selecione a disciplina que você precisa estudar ou revisar"
  },
  {
    step: 2,
    title: "Estude com flashcards",
    description: "Aprenda de forma ativa e eficiente com nossos cards"
  },
  {
    step: 3,
    title: "Revise constantemente",
    description: "Use o método de repetição espaçada para fixar o conteúdo"
  },
  {
    step: 4,
    title: "Acelere sua aprovação",
    description: "Conquiste sua aprovação estudando com estratégia"
  }
];

export const socialLinks = {
  youtube: "https://www.youtube.com/@odireitoem5minutos",
  instagram: "https://www.instagram.com/odireitoem5minutos/"
};

export const youtubeVideos = [
  "https://www.youtube.com/embed/Dfx7jVHBxeg",
  "https://www.youtube.com/embed/kZmvsBCDr48",
  "https://www.youtube.com/embed/1Hp3u2QjRSg"
];
